import { AccountMemberRole } from '../model/user.model';

const ROLE_RANKS: Partial<Record<AccountMemberRole, number>> = {
  [AccountMemberRole.CONSUMER]: 0,
  [AccountMemberRole.PARTICIPANT]: 1,
  [AccountMemberRole.CURATOR]: 2,
  [AccountMemberRole.ACCOUNT_ADMIN]: 3
};

export function isAtLeastRole(role: AccountMemberRole, minimumRole: AccountMemberRole): boolean {
  const rank = ROLE_RANKS[role];
  const minimumRank = ROLE_RANKS[minimumRole];
  return rank !== undefined && minimumRank !== undefined && rank >= minimumRank;
}
